import './index.scss';
import 'styles/components/_badges.scss';

(function ($) {
  'use strict';

  $('body')
    .on('show.bs.collapse', '.q-generic-list-item .collapse', e => {
      $(e.currentTarget)
        .parents('.q-generic-list-item')
        .addClass('q-collapse-open');
    })
    .on('hide.bs.collapse', '.q-generic-list-item .collapse', e => {
      $(e.currentTarget)
        .parents('.q-generic-list-item')
        .removeClass('q-collapse-open');
    });

  function init() {
    const $searchItem = $('.q-search-list-item');
    const $elements = $searchItem.find(
      '.q-title, .q-subtitle, .q-right-content'
    );

    $elements.on('click', function () {
      UserTracker.emit('event', {
        eventName: 'global search result clicked',
        data: {
          request_path: window.location.pathname,
          search_result_position_clicked: $(this)
            .parents('.q-search-list-item')
            .index(),
          search_result_title_clicked: $(this).text(),
          search_result_url_clicked:
            $(this).find('a').attr('href') || 'No link found',
          search_type: 'odin'
        }
      });
    });
  }

  $(document).on('turbolinks:load', () => {
    init();
  });
})(jQuery);
